import { makeStyles } from "tss-react/mui";

export const useStylesBorder = makeStyles()(theme => ({
   border: {
      backgroundColor: 'white',
      borderRadius: '15px',
      border: '1px solid #CECECE',
      overflow: 'auto',
      height: '60vh'
   }
}));